<template>
  <div class="modal-tags-container">
    <input-main :info-input="infoInput"
                :active-textarea="true"
                @changeValue="value => textRU = value.value"
                :value="textRU"/>
    <button-main @click="saveTag"
                 :disabled="!isValidInput"
                 :active="isValidInput"
    >
      {{ btnText }}
    </button-main>
  </div>
</template>

<script>
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import {mapActions} from "vuex";
import InputMain from "@/components/shared/input/InputMain.vue";
import ToggleWithTitle from "@/components/shared/toggle/ToggleWithTitle.vue";
import {api} from "@/middleware/api";
import {ca} from "vuetify/locale";

export default {
  name: "ModalTags",
  components: {ToggleWithTitle, InputMain, ButtonMain},
  data() {
    return {
      onComplete: () => '',
      isActiveEn: false,
      infoInput: {
        maxLength: 40,
        type: 'text',
        placeholder: 'Введите текст'
      },
      idTag: -1,
      textRU: '',
      textEN: '',
      btnText: 'Сохранить',
    }
  },
  created() {
    this.setInitialParams();
  },
  computed: {
    infoModal() {
      return this.isActiveModalName
    },
    params() {
      return this.infoModal.info?.tag;
    },
    isActiveEdit() {
      return this.idTag !== -1;
    },
    isValidInput() {
      let isActiveEn = this.isActiveEn
          ?  this.textEN !== ''
          : true
      return this.textRU !== '' && isActiveEn
    },
    resultArr() {
      return [
        {
          langCode: 'RU',
          content: this.textRU
        },
        {
          langCode: 'EN',
          content: this.textEN
        }
      ]
    },
  },
  methods: {
    ...mapActions('tags', ['ADD_TAG']),
    async saveTag() {
      let translations = this.isActiveEn ? this.resultArr : [this.resultArr[0]]
      this.IS_GLOBAL_LOADING(true)
      try {
        let response;
        if (this.isActiveEdit) {
          response = await api.dashboard.adminTagsControllerUpdate(this.idTag, {
            translations
          })
        } else {
          response = await api.dashboard.adminTagsControllerCreate({
            translations
          })
        }
        this.ADD_TAG(response.data)
        this.onComplete(response.data);
        this.alertSuccess(`Контент сохранен!`)
        this.MODAL(null);
      } catch (e) {
        console.log(e)
        this.alertError('Произошла ошибка!')
      } finally {
        this.IS_GLOBAL_LOADING(false)
      }
    },
    setInitialParams() {
      if(this.params) {
        this.textRU = this.params.valueRU;
        this.textEN = this.params?.valueEN || '';
        this.isActiveEn = !!this.params?.valueEN
        this.idTag = this.params.id;
      }
      this.onComplete = this.infoModal.onComplete;
    },
  }
}
</script>

<style scoped lang="scss">
  .modal-tags-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 32px;
    align-items: center;
    .v-input {
      width: 100%;
    }
    .modal-tags-content {
      width: 100%;
    }
  }
</style>